module.exports = __webpack_public_path__ + "img/second-block-bg.6c666e1a.jpg";